/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CodeType } from './CodeType';
import {
    CodeTypeFromJSON,
    CodeTypeFromJSONTyped,
    CodeTypeToJSON,
    CodeTypeToJSONTyped,
} from './CodeType';

/**
 * 
 * @export
 * @interface CodeRead
 */
export interface CodeRead {
    /**
     * 
     * @type {string}
     * @memberof CodeRead
     */
    name: string;
    /**
     * 
     * @type {CodeType}
     * @memberof CodeRead
     */
    type: CodeType;
    /**
     * 
     * @type {string}
     * @memberof CodeRead
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof CodeRead
     */
    problem_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CodeRead
     */
    user_id: string;
    /**
     * 
     * @type {Date}
     * @memberof CodeRead
     */
    created_at?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof CodeRead
     */
    is_active?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof CodeRead
     */
    last_used?: Date;
    /**
     * 
     * @type {string}
     * @memberof CodeRead
     */
    blockly_workspace?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CodeRead
     */
    teacher_comments?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CodeRead
     */
    id: string;
}



/**
 * Check if a given object implements the CodeRead interface.
 */
export function instanceOfCodeRead(value: object): value is CodeRead {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('user_id' in value) || value['user_id'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function CodeReadFromJSON(json: any): CodeRead {
    return CodeReadFromJSONTyped(json, false);
}

export function CodeReadFromJSONTyped(json: any, ignoreDiscriminator: boolean): CodeRead {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'type': CodeTypeFromJSON(json['type']),
        'code': json['code'],
        'problem_id': json['problem_id'] == null ? undefined : json['problem_id'],
        'user_id': json['user_id'],
        'created_at': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'is_active': json['is_active'] == null ? undefined : json['is_active'],
        'last_used': json['last_used'] == null ? undefined : (new Date(json['last_used'])),
        'blockly_workspace': json['blockly_workspace'] == null ? undefined : json['blockly_workspace'],
        'teacher_comments': json['teacher_comments'] == null ? undefined : json['teacher_comments'],
        'id': json['id'],
    };
}

export function CodeReadToJSON(json: any): CodeRead {
    return CodeReadToJSONTyped(json, false);
}

export function CodeReadToJSONTyped(value?: CodeRead | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'type': CodeTypeToJSON(value['type']),
        'code': value['code'],
        'problem_id': value['problem_id'],
        'user_id': value['user_id'],
        'created_at': value['created_at'] == null ? undefined : ((value['created_at']).toISOString()),
        'is_active': value['is_active'],
        'last_used': value['last_used'] == null ? undefined : ((value['last_used']).toISOString()),
        'blockly_workspace': value['blockly_workspace'],
        'teacher_comments': value['teacher_comments'],
        'id': value['id'],
    };
}

